import { all, takeLatest } from 'redux-saga/effects';

import * as AuthActionTypes from '@shared/redux/actions/auth-actions';
import * as LogoutSaga from '@shared/redux/sagas/logout-saga';

function* watchLogoutRequest() {
  yield takeLatest(AuthActionTypes.LOGOUT_REQUEST, LogoutSaga.fetchLogoutRequest);
}

export default function* watchAuthActions() {
  yield all([watchLogoutRequest()]);
}
